export default __webpack_public_path__ + "static/media/construction_news.38070edb.svg";